module.exports = __webpack_public_path__ + "static/media/Marketing@2x.b59c2bcd.png";